import { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';
import { TableConfig } from 'src/app/shared/components/generic-table';
import {
  createWalletTableConfig,
  WalletColumnKeys,
} from 'src/app/shared/table-configs/wallet-table-config.base';

export type ListGroupColumnKeys = WalletColumnKeys;

export const LIST_GROUP_NO_DATA_MESSAGE = $localize`:@@noDataDisplay:No hay datos para mostrar.`;

export const getListGroupTableConfig = (): TableConfig<WalletResponseDto, ListGroupColumnKeys> =>
  createWalletTableConfig();

export const listGroupTableConfig = getListGroupTableConfig();
